import 'core-js-bundle'
import 'array-flat-polyfill'
import cssVars from 'css-vars-ponyfill';
import Vue from 'vue'
import App from './App.vue'
import store from './store/index'
import VCalendar from 'v-calendar'

cssVars({
  // Options...
});
Vue.filter('highlight', function (word, query) {
  if (query.length >= 3) {
    let check = new RegExp(query.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), "ig");
    return word.toString().replace(check, function (matchedText) {
      return ('<span style="background-color: #AFB7CA">' + matchedText + '</span>');
    });
  } else {
    return word
  }
});

Vue.use(VCalendar);

Vue.config.productionTip = true;

new Vue({
  store,
  render: h => h(App)
}).$mount('#app');
